"use strict";

var _createForOfIteratorHelper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _get = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/get.js").default;
var _getPrototypeOf = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortFontCSSValidator = void 0;
var _ShortCSSToReactNativeValidator = require("./ShortCSSToReactNativeValidator");
var _normalizeFontName = _interopRequireDefault(require("./normalizeFontName"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var WHITESPACE_REGEX = /\s+/;
var ShortFontCSSValidator = /*#__PURE__*/function (_ShortCSSToReactNativ) {
  _inherits(ShortFontCSSValidator, _ShortCSSToReactNativ);
  var _super = _createSuper(ShortFontCSSValidator);
  function ShortFontCSSValidator() {
    _classCallCheck(this, ShortFontCSSValidator);
    return _super.apply(this, arguments);
  }
  _createClass(ShortFontCSSValidator, [{
    key: "normalizeInlineCSSValue",
    value: function normalizeInlineCSSValue(value) {
      // A 'font' declaration may end with a list of multiple font families.
      // We must check support for this list before processing.
      var resp = value.split(',');
      var fontFamily = null;
      if (resp.length === 1) {
        return _get(_getPrototypeOf(ShortFontCSSValidator.prototype), "normalizeInlineCSSValue", this).call(this, resp[0]);
      }
      var base = resp.splice(0, 1)[0];
      var _iterator = _createForOfIteratorHelper(resp),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var font = _step.value;
          var normalizedFont = (0, _normalizeFontName.default)(font);
          var isFontSupported = this.config.isFontSupported(normalizedFont);
          if (isFontSupported) {
            fontFamily = typeof isFontSupported === 'string' ? isFontSupported : normalizedFont;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return _get(_getPrototypeOf(ShortFontCSSValidator.prototype), "normalizeInlineCSSValue", this).call(this, base.split(WHITESPACE_REGEX).slice(0, -1).join(' ') + ' ' + (fontFamily || 'system'));
    }
  }]);
  return ShortFontCSSValidator;
}(_ShortCSSToReactNativeValidator.ShortCSSToReactNativeValidator);
exports.ShortFontCSSValidator = ShortFontCSSValidator;